import { useEffect, useState } from 'react'
import { get } from '../../../Services/api'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';
import calory_icon from '../../../resources/calories Chart.svg'
import protein_icon from '../../../resources/Group 1000003405.svg'
import carb_icon from '../../../resources/IconButton.png'
import fat_icon from '../../../resources/fat 1.png'

import './IntakeOverview.css'
import IntakeOverviewChart from './Chart';
import IntakeOverviewLineChart from './LineChart';
import Loading from '../../../Components/Loading/Loading';

function IntakeOverview({ currentUser }) {
    const days_week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    const [intakeDetail, setIntakeDetail] = useState([])
    const today = yyyy_mm_dd_date_format({})
    const [weekDates, setWeekDates] = useState([])
    const [timeFrame, setTimeFrame] = useState(7)
    const [details, setDetails] = useState([])
    const [totalCalories, setTotalCalories] = useState(0)
    const [totalProtein, setTotalProtein] = useState(0)
    const [totalCarb, setTotalCarb] = useState(0)
    const [totalFat, setTotalFat] = useState(0)

    function getWeekDates() {
        const result = []
        for (let i = timeFrame - 1; i >= 0; i--) {
            const date = yyyy_mm_dd_date_format({ i_date: today, sub_days: i })
            const date_utc = new Date(date + "T00:00:00Z");
            result.push({
                day_of_week: days_week[date_utc.getUTCDay()],
                date: yyyy_mm_dd_date_format({ i_date: today, sub_days: i })
            })
        }
        return result;
    }

    useEffect(() => {
        get_user_daily_meal_plan()

        // get week 
        setWeekDates(getWeekDates())
    }, [timeFrame])

    useEffect(() => {
        // get full detail based on timeframe preference
        setDetails(getDetails())
    }, [weekDates, intakeDetail])

    async function get_user_daily_meal_plan() {
        try {
            const resp = await get("/api/meal-plan/get-user-cpf-intake-last-n-days", {
                user_id: currentUser.uid,
                today_date: today,
                num_days: timeFrame
            })
            setIntakeDetail(resp)
            // Set total CPF
            setTotalCalories(resp.reduce((sum, item) => sum + parseInt(item.total_calories), 0))
            setTotalProtein(resp.reduce((sum, item) => sum + parseInt(item.total_protein), 0))
            setTotalCarb(resp.reduce((sum, item) => sum + parseInt(item.total_carb), 0))
            setTotalFat(resp.reduce((sum, item) => sum + parseInt(item.total_fat), 0))
        } catch (e) {
            // Could not fetch user meal plan or no meal plan is schedualed
            setIntakeDetail([])
        }
    }

    function getDetails() {
        if (timeFrame == 7) {
            return getWeekDetail()
        } else if (timeFrame == 28) {
            // return getWeekDetail()
            return getMonthDetail()
        } return []
    }

    // get graph ready array for 7 days
    function getWeekDetail() {
        const result = []
        weekDates.map((day) => {
            let calory = 0
            let protein = 0
            let carb = 0
            let fat = 0
            intakeDetail.map((intake) => {
                if (intake.meal_date === day.date) {
                    calory = parseInt(intake.total_calories)
                    protein = parseInt(intake.total_protein)
                    carb = parseInt(intake.total_carb)
                    fat = parseInt(intake.total_fat)
                }
            })
            result.push({
                label: timeFrame == 7 ? day.day_of_week : date_to_month_day(day.date),
                data: {
                    calories: calory,
                    protein: protein,
                    carb: carb,
                    fat: fat
                }
            })
        })
        return result
    }

    function date_to_month_day(date) {
        const date_split = date.split('-')
        return months[parseInt(date_split[1]) - 1] + ' ' + date_split[2]
    }

    // get graph ready array for 28 days
    function getMonthDetail() {
        const result = [];
        let weekGroup = [];
        let currentWeekIndex = 0;

        // Return month of date
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        function getDateMonth(dateString) {
            return months[parseInt(dateString.split("-")[1]) - 1]
        }
        // Group weekDates into 7-day intervals
        weekDates.map((day, i) => {
            weekGroup.push(day);
            if (weekGroup.length === 7 || i === weekDates.length - 1) {
                let totalCalories = 0;
                let totalProtein = 0;
                let totalCarbs = 0;
                let totalFat = 0;

                // Sum the intake values for the current week group
                weekGroup.forEach((day) => {
                    intakeDetail.forEach((intake) => {
                        if (intake.meal_date === day.date) {
                            totalCalories += parseInt(intake.total_calories, 10);
                            totalProtein += parseInt(intake.total_protein, 10);
                            totalCarbs += parseInt(intake.total_carb, 10);
                            totalFat += parseInt(intake.total_fat, 10);
                        }
                    });
                });

                // Push the grouped data into the result array
                result.push({
                    label: weekGroup[0].date.split('-')[2] + ' - ' + weekGroup[weekGroup.length - 1].date.split('-')[2] + ' ' + getDateMonth(weekGroup[weekGroup.length - 1].date),
                    data: {
                        calories: totalCalories,
                        protein: totalProtein,
                        carb: totalCarbs,
                        fat: totalFat
                    }
                });

                // Reset for the next group
                weekGroup = [];
                currentWeekIndex++;
            }
        })
        return result
    }


    return (
        <div className="component_padding black">
            <div className='dashboard-intake-overview-heading flex align_center justify_space_between'>
                <h4 className='font_family_ovo no_margin'>Intake Overview</h4>

                <div className="dashboard-intake-overview-range-picker-div">
                    <select className='dashboard-intake-overview-range-picker gray_scale_2' onChange={(e) => setTimeFrame(e.target.value)}>
                        <option value={7}>Last Week</option>
                        <option value={28}>Last 28 Days</option>
                    </select>
                    <svg
                        className="ashboard-intake-overview-range-picker-custom-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="none"
                        stroke="#5A5855"
                        strokeWidth="2"
                    >
                        <polyline points="5,7 10,12 15,7" />
                    </svg>
                </div>
            </div>

            <div className='dashboard-intake-overview-calory-icon-all-div'>
                <div className='flex gap_10'>
                    <div className='dashboard-intake-overview-calory-icon flex align_center justify_center'>
                        <img src={calory_icon} />
                    </div>

                    <div className='flex flex_column justify_space_between'>
                        <p className='font_weight_600 font_size_14 gray_scale_1 no_margin'>{totalCalories >= 1000 ? (totalCalories / 1000).toFixed(2) + 'K' : totalCalories}</p>
                        <p className='font_size_12 gray_scale_5 no_margin'>Calories</p>
                    </div>
                </div>
                <div className='flex gap_10'>
                    <div className='dashboard-intake-overview-protein-icon flex align_center justify_center'>
                        <img src={protein_icon} />
                    </div>

                    <div className='flex flex_column justify_space_between'>
                        <p className='font_weight_600 font_size_14 gray_scale_1 no_margin'>{totalProtein >= 1000 ? (totalProtein / 1000).toFixed(2) + 'K' : totalProtein}</p>
                        <p className='font_size_12 gray_scale_5 no_margin'>Protein</p>
                    </div>
                </div>
                <div className='flex gap_10'>
                    <div className='dashboard-intake-overview-carb-icon flex align_center justify_center'>
                        <img src={carb_icon} width={40} />
                    </div>

                    <div className='flex flex_column justify_space_between'>
                        <p className='font_weight_600 font_size_14 gray_scale_1 no_margin'>{totalCarb >= 1000 ? (totalCarb / 1000).toFixed(2) + 'K' : totalCarb}</p>
                        <p className='font_size_12 gray_scale_5 no_margin'>Carbohydrate</p>
                    </div>
                </div>
                <div className='flex gap_10'>
                    <div className='dashboard-intake-overview-carb-icon flex align_center justify_center'>
                        <img src={fat_icon} width={25} />
                    </div>

                    <div className='flex flex_column justify_space_between'>
                        <p className='font_weight_600 font_size_14 gray_scale_1 no_margin'>{totalFat >= 1000 ? (totalFat / 1000).toFixed(2) + 'K' : totalFat}</p>
                        <p className='font_size_12 gray_scale_5 no_margin'>Fat</p>
                    </div>
                </div>
            </div>

            <div className='dashboard-intake-overview-intake-overview-all-div'>
                <div>
                    <IntakeOverviewChart details={details} />
                </div>
                {/* <div>
                    <IntakeOverviewLineChart details={details} />
                </div> */}
            </div>
        </div>
    );
}


export default IntakeOverview;